module.exports = __webpack_public_path__ + "img/CD-dots2.153985d5.svg";